<script setup>
import { onMounted, onUnmounted, defineProps } from "vue";
import AMapLoader from "@amap/amap-jsapi-loader";
const props = defineProps({
  mapflagaddress: {
    type: String,
    required: true,
  },
});
let map = null;
let marker = null;
let address = null;
let loc = {
  longitude: "",
  latitude: "",
};
// 定义 emits
const emit = defineEmits(["update"]);

onMounted(() => {
  window._AMapSecurityConfig = {
    securityJsCode: "c3ff60bb85d9d2abecc1ac45175f8320",
  };
  AMapLoader.load({
    key: "e468d452e59db2d288aa54aee38e2e29",
    version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    plugins: [
      "AMap.ToolBar",
      "AMap.Scale",
      "AMap.Geolocation",
      "AMap.CitySearch",
      "AMap.AutoComplete",
      "AMap.PlaceSearch",
      "AMap.MarkerClusterer",
      "AMap.DistrictSearch",
      "AMap.ZoomControl",
      "AMap.Polygon",
      "AMap.Geocoder",
      "AMap.MouseTool",
      "AMap.PolyEditor",
      "AMap.CircleEditor",
      "AMap.InfoWindow",
      "AMap.Autocomplete",
    ], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
  })
    .then((AMap) => {
      map = new AMap.Map("container", {
        // 设置地图容器id
        viewMode: "3D", // 是否为3D地图模式
        zoom: 10, // 初始化地图级别
        center: [116.397428, 39.90923], // 初始化地图中心点位置
        // center: [loc.longitude, loc.latitude], // 初始化地图中心点位置
        mapStyle: "amap://styles/bb600e31122fb1e8180d1f77c9e052d0", // 使用自定义样式
      });
      console.log(666);

      // 使用地理编码服务
      var geocoder = new AMap.Geocoder({
        // city: "010", //城市设为北京，默认：“全国”
        city: "晋城市", //城市设为北京，默认：“全国”
      });

      // 设置自定义图标
      var markerIcon = new AMap.Icon({
        // 图标 url
        // src: 'image://' + require('../assets/imgOne22.png'), // 替换为你的图标 URL

        // 图标尺寸
        // size: new AMap.Size(60, 150),
        size: new AMap.Size(82, 51),
        // 图标的取图地址
        image: require("../assets/imgOne22.png"),
        // 图标所用图片大小
        // imageSize: new AMap.Size(55, 150),
        imageSize: new AMap.Size(82, 51),
        // 图标取图偏移量
        imageOffset: new AMap.Pixel(0, 0),
      });

      // 创建 Marker
      const marker = new AMap.Marker({
        // position: [116.397428, 39.90923], // Marker 的位置
        icon: markerIcon, // 设置图标
      });
      let city = [
        { lnglat: [112.85457, 35.585421], name: "xxx", style: 2 },
        { lnglat: [112.891611, 35.448659], name: "xxxx", style: 2 },
        { lnglat: [112.967487, 35.929718], name: "xxxxx", style: 2 },
        { lnglat: [113.017071, 35.920751], name: "xxxxxx", style: 2 },
        { lnglat: [112.838586, 35.437868], name: "xxxxx", style: 2 },
        { lnglat: [112.242522, 35.538257], name: "xxxxxx", style: 2 },
        { lnglat: [113.278877, 35.775614], name: "xxxxxx", style: 2 },
        { lnglat: [113.59589, 35.63147], name: "xxxxxx", style: 2 },
        { lnglat: [112.187213, 35.689472], name: "xxxxxx", style: 2 },
        { lnglat: [112.186717, 35.817277], name: "xxxxxx", style: 2 },
        { lnglat: [112.422014, 35.482177], name: "xxxxxx", style: 2 },
        { lnglat: [112.454573, 35.609237], name: "xxxxxx", style: 2 },
        { lnglat: [113.148042, 35.3547177], name: "xxxxxx", style: 2 },
        { lnglat: [112.838788, 35.585096], name: "xxxxxx", style: 2 },
      ];

      // 批量创建 Marker
      city.map((item) => {
        console.log("item:", item, item.lnglat);

        let marker = new AMap.Marker({
          map: map,
          position: item.lnglat, // Marker 的位置
          icon: markerIcon, // 设置图标
        });

        marker.setLabel({
          offset: new AMap.Pixel(20, 20), //设置文本标注偏移量
          // content: `<div class='infomarker' style='color:#fff'>${item.name}</div>`, //设置文本标注内容
          direction: "top", //设置文本标注方位
        });

        // 固定弹框的位置，这里以 [116.4, 39.9] 为例
        const fixedPosition = [116.4, 39.9];
        // 创建 InfoWindow
        const infoWindow = new AMap.InfoWindow({
          // content: `<div calss="infoWindow" style="padding:10px;">
          //    醉美盐池餐厅助餐点助餐记录
          //    <div></div>
          //    </div>`, // 弹框内容
          content: `<div class="infoWindow"
        style="padding:25px 15px 0px ; box-sizing: border-box; position: relative;z-index:1000 ;width: 300px;">
        <div class="title"> 护理员基本信息</div>
        <div class='bgimg'
         style="
                position: absolute;
                right: 20px;
                top:52px;
                width: 110px;
                height: 97px;
                border-radius: 10px">
        </div>

        <div class='bgimg'
            style="
            position: absolute; 
            right: 20px;
            top:178px;
            width: 110px; 
            height: 97px; 
            border-radius: 10px"
            >
        </div>
        <div class="div">
            <span>姓名：</span>
            <span>张三</span>
        </div>
        <div class="div">
            <span>性别：</span>
            <span>男</span>
        </div>
        <div class="div">
            <span>行业年龄：</span>
            <span>30</span>
        </div>
        <div class="div">
            <span>证书名称</span>
            <span>某某执照</span>
        </div>

        <div class="title">工单信息</div>

        <div class="div">
            <span>姓名：</span>
            <span>张三</span>
        </div>
        <div class="div">
            <span>性别：</span>
            <span>男</span>
        </div>
        <div class="div">
            <span>护理等级：</span>
            <span>一级护理</span>
        </div>

        <div class="div">
            <span>开始时间：</span>
            <span>2025年2月23日 9:00</span>
        </div>

        <div class="div">
            <span>结束时间：</span>
            <span>2025年2月23日 18:00</span>
        </div>

        <div class="div">
            <span>时长：</span>
            <span>8小时</span>
        </div>
        <div class="div">
            <span>服务地址：</span>
            <span>山西xxxxxxxx</span>
        </div>
        <div class="div">
            <span>服务内容：</span>
            <span>理疗、居家保洁</span>
        </div>
    </div>`, // 弹框内容
          // offset: new AMap.Pixel(0, -30), // 内容的位置偏移量
          offset: new AMap.Pixel(100, 0), // 内容的位置偏移量
          // position: new AMap.Pixel(100, 0), // 内容的位置偏移量
        });

        // 为 Marker 添加点击事件
        marker.on("click", () => {
          infoWindow.open(map, marker.getPosition()); // 打开 InfoWindow，且位置在 Marker 位置
        });
      });

      var center = map.getCenter();

      map.setFitView();

      let address = props.mapflagaddress;
      geocoder.getLocation(address, function (status, result) {
        if (status === "complete" && result.geocodes.length) {
          var lnglat = result.geocodes[0].location; // 获取经纬度
          map.setCenter([lnglat.lng, lnglat.lat]); // 设置地图中心
        } else {
          log.error("根据地址查询位置失败");
        }
      });
    })
    .catch((e) => {
      // console.log(e);
    });
});

onUnmounted(() => {
  map?.destroy();
});
</script>

<template>
  <div style="width: 100%; height: 100%; position: relative">
    <div id="container"></div>
    <div
      class="returnBtn"
      @click="
        () => {
          emit('setMapInfo2');
        }
      "
    >
      返回
    </div>
  </div>
</template>

<style scoped lang="less">
#container {
  width: 1920px;
  height: 1080px;
  position: relative;
  left: 50%;
  top: 68%;
  transform: translate(-50%, -50%);
}

.returnBtn {
  position: absolute;
  top: 10px;
  right: 15px;
  color: azure;
  cursor: pointer;
  font-size: 13px;
  padding: 5px 10px;
  background-color: Rgb(6, 71, 98);
  border-radius: 5px;
}

.infomarker {
  // background-color: #ff0000;
}

::v-deep .amap-info-content {
  background: url(../assets/modelBg1.png) no-repeat center center / 100% 100%;
  min-width: 300px;
  min-height: 200px;
  // max-height: 400px;
  color: #fff;
  font-size: 14px;

  .title {
    position: relative;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-indent: 20px;

    &::after {
      content: "";
      position: absolute;
      left: 0px;
      top: 50%;
      transform: translateY(-50%);
      width: 15px;
      height: 14px;
      background: url(../assets/titleicon.png) no-repeat center center / 100%
        100%;
    }
  }

  .bgimg {
    background: url(../assets/imgmap2.png) no-repeat center center / 100% 100%;
  }

  .div {
    font-size: 12px;
    color: #ffffff;
    margin: 11px 10px;
    text-indent: 11px;
  }

  .div span:nth-child(2) {
    display: inline-block;
    color: rgba(87, 243, 240, 1);
  }
}

::v-deep .amap-info-sharp {
  background-color: #083dec;
  display: none;
}

::v-deep .amap-marker-label {
  background-color: transparent;
  border: 0 none;

  .infomarker {
    background: url(../assets/imgTwo.png) no-repeat center center / cover;
    min-width: 100px;
    min-height: 50px;
    color: #fff;
    white-space: normal;
    text-align: left;
    padding: 7px 5px;
    box-sizing: border-box;
    overflow: hidden;
    /*隐藏溢出部分 */
    text-overflow: ellipsis;
    /* 溢出文本用省略号表示 */
  }
}
</style>